import { Route, Routes, Navigate } from 'react-router-dom'
import { prependPathWithParams } from '@dhl/utils'
import { useCurrentUser } from '~/common'
import { PromotionsRoutes, promotionsLinks } from '~/modules/dhl-extra/view/PromotionsRoutes'
import { AuthWrapped } from '~/modules/navigation/components'

export const PATH = {
  PROMOTIONS: 'promotions',
}

export const DhlExtraRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('MARKETING')
  return (
    <Routes>
      <Route
        path={`${PATH.PROMOTIONS}/*`}
        element={<AuthWrapped component={PromotionsRoutes} canAccess={canAccess} />}
      />
      <Route index element={<Navigate to={PATH.PROMOTIONS} />} />
    </Routes>
  )
}

export const dhlExtraLinks = {
  promotionsOverviewLink: () => `/${PATH.PROMOTIONS}`,
  ...prependPathWithParams(() => PATH.PROMOTIONS, promotionsLinks),
}
